export default __webpack_public_path__ + "static/13-medication-537f5680e039104347ceed422edc1768.png";